import { render } from "./NotFound.vue?vue&type=template&id=54f09ceb&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=54f09ceb&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54f09ceb"]])

export default __exports__